<div *ngIf="isLoading">Loading...</div>
<div *ngIf="error">{{ error }}</div>

<div *ngIf="!isLoading && professor">
  <h2>Professor Profile</h2>
  <p><strong>ID:</strong> {{ professor.id }}</p>
  <p><strong>First Name:</strong> {{ professor.firstName }}</p>
  <p><strong>Last Name:</strong> {{ professor.lastName }}</p>
  <p><strong>Email:</strong> {{ professor.email }}</p>
  <!-- Add more fields as needed -->
</div>